<div class="wrapper">
    <h1 mat-dialog-title style="display: inline-block; cursor: move">
        Select a vessel
    </h1>
    <br />
    <h2 mat-dialog-title style="display: inline-block; cursor: move">
        Builder: {{ builderName }}
    </h2>
    <br />
    <div class="search-register-area">
        <label class="search-input"
            >Search:
            <input
                type="text"
                name="search"
                [(ngModel)]="searchText"
                (input)="filterVessels($event)"
        /></label>
    </div>
    <table>
        <tr>
            <th class="table-title">Vessel Name</th>
        </tr>
    </table>
    <div class="vesselListTable">
        <table>
            <tr *ngFor="let d of filteredVessels" (click)="rowClick(d)">
                <td>{{ d.vesselNumber }}</td>
                <td>{{ d.name }}</td>
            </tr>
        </table>
    </div>
</div>
